"use strict";

exports.__esModule = true;
exports.getDurationText = exports.getDurationFromMinutes = void 0;
var _dateAndTime = require("../dateAndTime/dateAndTime");
var _bookingsUouMappers = require("@wix/bookings-uou-mappers");
const getDurationText = ({
  rfcStartTime,
  rfcEndTime,
  t,
  dateRegionalSettingsLocale
}) => {
  const durationInMinutes = (0, _dateAndTime.differencesBetweenTwoDates)(rfcStartTime, rfcEndTime, _dateAndTime.TimeUnits.minute);
  return getDurationFromMinutes({
    minutes: durationInMinutes,
    t,
    dateRegionalSettingsLocale
  });
};
exports.getDurationText = getDurationText;
const getDurationFromMinutes = ({
  minutes,
  t,
  dateRegionalSettingsLocale
}) => {
  const durationOptions = {
    hourUnit: 'duration.units.hours',
    hourAriaUnit: 'duration.units.aria-hours',
    minuteUnit: 'duration.units.minutes',
    minuteAriaUnit: 'duration.units.aria-minutes'
  };
  const durationMapper = new _bookingsUouMappers.DurationMapper(dateRegionalSettingsLocale, durationOptions, t);
  return {
    durationText: durationMapper.durationTextFromMinutes(minutes),
    durationAriaText: durationMapper.durationAriaLabelFromMinutes(minutes)
  };
};
exports.getDurationFromMinutes = getDurationFromMinutes;
//# sourceMappingURL=duration.js.map